export default __webpack_public_path__ + "static/media/bee_shot.8f6d8bba.wav";